import React, { useState } from "react"
import firebase from "./firebase.js"

function Project(props) {
    const {source,img,plink,tags,name} = props.imgdata;
    const tagsarray = tags.split(",")
    return (
        <>
            <div className="project_wrapper">
                <p className="project_name">{name}</p>
                <div className="project_img">
                    <img src={img} alt={name} />
                </div>
                <div className="project_links">
                    <a href={source}>Source Code</a>
                    <a href={plink}>Go to Project</a>
                </div>
                <div className="tags">
                    {tagsarray.map((tag,index)=>{
                        return <p key={100*index}>{tag}</p>
                    })}
                </div>
            </div>
        </>
    )
}

export default Project;
